<template>
    <div class="m-choosePark">
        <el-row>
            <el-col :span="24">
                <el-tabs v-model="activeName" v-if="itemList.length">
                    <el-tab-pane :label="item.city" :name="item.city" v-for="(item,index) in itemList" :key="index">
                        <el-row>
                            <section class="cityTop clearfix" :class="{'top30': isChoose}">
                                <el-carousel :autoplay="false" :height="height*multiple+'px'" :indicator-position="'none'">
                                    <el-carousel-item v-for="(groupIndex, index_1) in getCardNum(item)" :key="index_1">
                                        <el-col style="width: 200px;height: 180px;" v-for="(project,index_2) in listCmputed(item.projects, groupIndex)" :key="index_2">
                                            <el-card :body-style="{ padding: '5px' }" class='CarBox' :class="{'checked': project.checked || (project.id == projectId && !isChoose) }">
                                                <div @click.stop="changeProject(project)">
                                                    <div class="img-con">
                                                        <img :src="project.projectImg" class="image" v-if="project.projectImg"/>
                                                        <img src='../assets/img/park.png' class="image" v-else/>
                                                    </div>
                                                    <span class="city">{{project.city}}</span>
                                                    <div class="cityNameA oneLine" :title="project.projectName" v-text="project.projectName"></div>
                                                </div>
                                                <i class="icon-check" v-if="isChoose"></i>
                                            </el-card>
                                        </el-col>
                                    </el-carousel-item>
                                </el-carousel>
                            </section>
                            <div class="pro-info-footer">
                                <div class='info cityFooter-number1' @click='showALL'>
                                    {{showAllTittle}}
                                    <i :class="showAllProject?'el-icon-caret-bottom':'el-icon-caret-top'"></i>
                                </div>
                            </div>
                            <div class="checkedList" :class="{ 'p-b-40': !isRegister }" v-if="isChoose && checkedList.length > 0">已经选择 <span class="num">{{checkedList.length}}</span> 个园区</div>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
        
    </div>
</template>

<script>

import API from '@/fetch/api'
import * as access from '@/config/access';

export default {
    props: {
        isChoose: { //默认false, 顶部切换园区，true表示是选择园区
            type: Boolean,
            default: false
        },
        chooseIds: { //默认选中的园区ID
            type: Array,
            default: ()=>{
                return []
            }
        },
        isRegister: {
            type: Boolean,
            default: false
        },
        initChooseIds: { //不能取消勾选的园区
            type: Array,
            default: ()=>{
                return []
            }
        }
    },
    data(){
        return {
            showAllTittle: "全部显示",
			showAllProject: false,
			height: 180,
            cardNum: 4,
			multiple: 1,
            itemList: [], //切换项目数组
            userParks: [], //用户可选园区
            activeName: this.isChoose ? '全部' : access.session('city') || '全部', //初始化城市
            checkedList: [], //选中的城市
            projectId: access.session('projectId') || ''
        }
    },
    mounted(){
		let vm = this;
        if(!vm.isChoose){
            // 如果是顶部切换园区的话需要筛选出只有用户选择过的园区
            // 查询用户所选园区
            vm.getUserPark().then(vm.getProject)
            return;
        }
        vm.getProject();
    },
    computed: {
        /* checkedList(){
            let arr = [];
            for(let i = 0; i < this.itemList.length; i++){
                for(let k = 0; k < this.itemList[i].projects.length; k++){
                    // 除了全部中的，其他的全部算上
                    if(this.itemList[i].projects[k].checked && this.itemList[i].city != '全部') arr.push(this.itemList[i].projects[k]);
                }
            }
            return arr;
        } */
    },
    methods: {
        // 获取用户选择过的园区
        getUserPark(resolve){
            let vm = this;
            return new Promise((resolve, reject) => {
                API.http({ url: '/merchant/users/park/list', type: 'post'}).then(res => {
                    if(res.code == 200){
                        vm.userParks = res.data || [];
                        // 有园区且未设置过、设置过，但原来的已经被取消了
                        if(vm.userParks.length){
                            // 是否是当前选中的园区被删掉
                            const isDelPark = vm.projectId && vm.userParks.findIndex(item=>item.parkId == vm.projectId) == -1
                            if(!vm.projectId || isDelPark){
                                access.session('projectId', vm.userParks[0].parkId);
                                access.session('projectName', vm.userParks[0].parkName);
                                access.session('city', vm.userParks[0].city);
                                vm.$emit("changeProject", vm.userParks[0])
                            }
                        }else{
                            access.session('projectId', "");
                            access.session('projectName', "");
                            access.session('city', "");
                            vm.$emit("refrashStatus")

                        }
                        access.session('userParks', vm.userParks);
                        resolve();
                        return;
                    }
                    reject();
                    vm.$showAlert(res.message || '获取用户可选园区信息失败，请刷新重试', 'error');
                }).catch((res)=>{
                    vm.$showAlert(res.message || '获取用户可选园区信息失败， 请刷新重试', 'error');
                    reject();
                })
            })
        },
        setInitChecked(){
            let vm = this;
            for(let s = 0; s < vm.chooseIds.length; s++){
                for(let i = 0; i < vm.itemList.length; i++){
                    for(let k = 0; k < vm.itemList[i].projects.length; k++){
                        if(vm.chooseIds[s] == vm.itemList[i].projects[k].id){
                            vm.$set(vm.itemList[i].projects[k], 'checked', true);
                            vm.checkedList.push(vm.itemList[i].projects[k]);
                        }
                    }
                }
            }
            vm.$emit('changeProject', vm.checkedList);
        },
        // 获取园区
        getProject(){
            let vm = this;
            API.http({ url: '/merchant/getProject', type: 'get'}).then(res => {
                if(res.code == 200){
                    vm.itemList = res.data || [];
                    let allList = {
                        city: '全部',
                        projects: []
                    };
                    // 添加选中的状态
                    if(vm.isChoose){
                        let parkList = [];
                        for(let i = 0; i < res.data.length; i++){
                            for(let k = 0; k < res.data[i].projects.length; k++){
                                vm.$set(vm.itemList[i].projects[k], 'checked', false);
                            }
                        }
                        vm.setInitChecked();
                    }else{ //过滤掉用户没有选择的园区
                        vm.itemList = vm.filterNoChoose(vm.itemList);
                    }
                    allList.projects = vm.getAll(vm.itemList);
                    // 全部插入到最前面
                    vm.itemList.unshift(allList);
                    // 初始化默认园区
                    if(!vm.activeName) vm.activeName = vm.itemList[0].city;
                    return;
                }
                vm.$showAlert(res.message || '获取园区信息失败', 'error');
            }).catch((res)=>{
                vm.$showAlert(res.message || '获取园区信息失败', 'error');
            })
        },
        // 顶部选择园区的地方，需要过滤掉用户未选择的园区
        filterNoChoose(list){
            let vm = this;
            let choosePark = [];
            for(let i = 0; i < list.length; i++){
                let park = {
                    city: list[i].city,
                    projects: []
                };
                for(let k = 0; k < list[i].projects.length; k++){
                    // 判断用户是否有该园区
                    for(let s = 0; s < vm.userParks.length; s++){
                        if(vm.userParks[s].parkId == list[i].projects[k].id){
                            park.projects.push(list[i].projects[k]);
                        }
                    }
                }
                if(park.projects.length > 0){
                    choosePark.push(park);
                }
            }
            return choosePark;
        },
        getAll(list){ //获取全部园区，用作显示全部园区
            let all = [], item = [];
            for(let i = 0; i < list.length; i++){
                if(list[i].projects.length < 1) continue;
                item = list[i].projects;
                for(let k = 0; k < item.length; k++){
                    all.push(item[k]);
                }
            }
            return all;
        },		
        checkChoose(projectId){
            let vm = this;
            if(!vm.isChoose) return false;
            return vm.checkedList.filter(item=>item.projectId == projectId)[0] 
        },
        // 点击的有可能是全部或者是其他城市，所以需要相互勾选
        setChecked(project){
            let vm = this;
            // 默认园区不能取消
            if(vm.initChooseIds.indexOf(project.id) > -1 && !vm.isRegister){
                vm.$showAlert('原有园区不能取消选择', 'warning');
                return;
            }
            let chooseId = project.id, checked = !project.checked;
            // 
            for(let i = 0; i < vm.itemList.length; i++){
                if(!vm.itemList[i].projects || vm.itemList[i].projects.length < 1) continue;
                for(let k = 0; k < vm.itemList[i].projects.length; k++){
                    if(chooseId == vm.itemList[i].projects[k].id) {
                        vm.$set(vm.itemList[i].projects[k], 'checked', checked);
                        vm.changeSel(chooseId, checked, vm.itemList[i].projects[k], vm.itemList[i].city == '全部');
                        
                    }
                }
            }
            this.$emit('changeProject', vm.checkedList);
        },
        // 选中状态变化，需要对应修改 checkedList
        changeSel(chooseId, checked, project, isAll){
            let vm = this;
            if(checked) {
                !isAll && vm.checkedList.push(project);
            }else{
                vm.checkedList = vm.checkedList.filter(item=>item.id != chooseId);
            }
            return true;
        },
		changeProject(project) {
            let vm = this
            if(vm.isChoose){
                vm.setChecked(project);
                return;
            }
            this.$emit('changeProject', project);
        },
        getParkList(){//父组件获取选中园区
            return this.checkedList;
        },
        // 计算每页展示多少个
        listCmputed: function(list, parentIndex) {
            let vm = this;
            let num = this.cardNum * this.multiple;
            return list.filter(function(item, index) {
                if ((index + 1) > (parentIndex - 1) * num && (index + 1) <= parentIndex * num) {
                    return item;
                }
            })
        },
        // 计算有多少个大面板
		getCardNum(item) {
            let num = Math.ceil(item.projects.length / (this.cardNum * this.multiple));
            return num;
        },
        showALL() { //显示全部城市
            let vm = this;
            if (!vm.showAllProject) {
                vm.showAllTittle = "收回显示";
                vm.height = vm.multiple * 200;
                let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                let objH = height - 180;
                if (objH < 180) {
                    vm.multiple = 1
                } else {
                    vm.multiple = Math.floor(objH / 200);
                }
            } else {
                vm.showAllTittle = "全部显示"
                vm.height = 180;
                vm.multiple = 1;
            }
            vm.showAllProject = !vm.showAllProject;
        }
    }
}
</script>

<style lang="scss">
@import '../style/variable';
    .m-choosePark{
        background: $c1;
        height: auto;
        .el-tabs__nav-wrap{
            margin-bottom: 0;
        }
        .el-tabs__nav-wrap.is-scrollable{
            padding: 0 50px;
            z-index: 1;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev{
            line-height: 50px;
            width: 50px;
            height: 50px;
            text-align: center;
            color: $c4;
            font-size: $fs_16;
            font-weight: 600;
            z-index: 2;
            background-color: $c13;
            &.el-tabs__nav-prev{
                box-shadow:0px 0px 4px 0px rgba($c0, 0.6);
            }
            &.el-tabs__nav-next{
                box-shadow:0px 10px 4px 0px rgba($c0, 1);
            }
        }
        .el-tabs__header {
            border-bottom: 1px solid $c12;
            background-color: $c13;
            margin: 0;
            display: flex;
            justify-content: center;
        }
        .el-tabs__nav {
            margin-left: 0;
        }
        .pro-info-footer {
            border-top: 1px solid $c12;
            background: $c13;
            height: 50px;
            line-height: 50px;
            .info {
                display: inline-block;
                margin-left: 30px;
                span {
                    font-size: 18px;
                    font-weight: bold;
                }
                &:first-child {
                    margin-left: 50px;
                }
                font-size: 12px;
            }
        }
        /* .el-tabs__nav-scroll {
            .el-tabs__nav {
                width: 100% !important;
            }
        } */
        .cityFooter-number {
            margin-left: 22px;
            margin-right: 70px;
        }
        .cityFooter-number1 {
            width: 86px;
            height: 26px;
            line-height: 26px;
            float: right;
            margin-top: 11px;
            font-size: 12px;
            cursor: pointer;
            margin-right: 50px;
            border: 1px solid $c14;
            text-align: center;
            color: $c15 !important;
            i {
                font-size: 14px;
            }
            &:hover {
                border-color: $c4;
                color: $c4 !important;
            }
        }
        .cityConnents {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
        }
        .cityTop {
            padding: 10px 0;
            &.top30{
                padding-top: 30px;
            }
            .el-carousel {
                padding-right: 20px;
                .el-carousel__container {
                    .el-carousel__arrow--right {
                        right: -4px;
                    }
                    .el-carousel__item {
                        text-align: center;
                        .el-col {
                            margin-left: 20px;
                            float: none;
                            display: inline-block;
                            .el-card {
                                box-shadow: none;
                                position: relative;
                                .city {
                                    font-size: 14px;
                                    color: $c1;
                                    position: absolute;
                                    left: 5px;
                                    cursor: pointer;
                                    top: 5px;
                                    z-index: 99;
                                    width: 190px;
                                    text-align: center;
                                    line-height: 130px;
                                    height: 130px;
                                    opacity: 0;
                                    background: rgba($c0, .3);
                                }
                                &:hover {
                                    .city {
                                        font-size: 30px;
                                        opacity: 1;
                                        transition: all 0.3s linear;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            &.alignLeft {
                .el-carousel {
                    .el-carousel__container {
                        .el-carousel__item {
                            text-align: left;
                        }
                    }
                }
            }
        }
        .el-card {
            border-radius: 0;
            &.CarBox {
                position: relative;
                .icon-check{
                    position: absolute;
                    top: 13px;
                    right: 13px;
                    width: 22px;
                    height: 22px;
                    background: url('../assets/img/icon/uncheck.png') no-repeat;
                    background-size: cover;
                }
                &:hover {
                    border: 1px solid $c4;
                    color: $c4;
                }
                &.checked{
                    border: 1px solid $c4;
                    color: $c4;
                    .icon-check{
                        background-image: url('../assets/img/icon/checked.png');
                    }
                }
                .img-con {
                    width: 190px;
                    height: 130px;
                    overflow: hidden;
                    img {
                        cursor: pointer;
                        transition: all 0.3s linear;
                        display: block;
                        width: 190px;
                        height: 130px;
                        object-fit: cover;
                    }
                }
                &:hover {
                    img {
                        -webkit-transform: scale(1.1);
                        -o-transform: scale(1.1);
                        -moz-transform: scale(1.1);
                        transform: scale(1.1);
                    }
                }
                .cityNameA {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    margin: 12px 0;
                    height: 14px;
                    cursor: pointer;
                    width: 190px;
                    line-height: 14px;
                    text-align: center;
                }
            }
        }
        .el-tabs__nav-scroll {
            .el-tabs__active-bar {
                height: 0;
            }
            .el-tabs__nav {
                display: flex;
                justify-content: center;
                background-color: $c13;
            }
            .el-tabs__item {
                padding: 0 8px;
                height: 50px;
                line-height: 50px;
                font-size: 16px;
                text-align: center;
                transition: all .2s;
            }
            .el-tabs__item:hover {
                color: $c4;
            }
            .is-active {
                color: $c4;
                border-radius: 5px;
                font-size: 20px;
                font-weight: bold;
                transition: all .2s;
            }
        }
        .checkedList{
            text-align: center;
            font-size: $fs_16;
            margin-top: 40px;
            .num{
                color: $c4;
            }

        }
    }
</style>